// Belgian eID verification error categories. Mirrors the keys used in
// `terminal/components/verificationBlocker/messages.js` — each category has a
// trilingual title + body. The mapping below resolves the native bridge's
// `Code` field (numeric or string, ships in `window.belgianVerificationResult`)
// to one of these categories.
//
// TODO: replace the placeholder code numbers with the real values from the
// C# / native side once the spec is locked. Keeping them here (rather than
// inline in the dispatcher) so they're easy to audit + adjust as one block.

export const BELGIAN_ERROR_KEYS = {
  EXCLUDED: 'excluded',
  UNDER_AGE: 'under_age',
  EXPIRED: 'expired',
  UNREADABLE: 'unreadable',
  UNAVAILABLE: 'unavailable',
};

// Code → category map. Accepts both numeric and string codes — the resolver
// normalises both to a string key before lookup. Add entries as the native
// side defines new error codes; unknown codes fall back to `unavailable`.
const CODE_TO_KEY = {
  // Numeric placeholders — replace with the real values shipped by the C# side.
  1001: BELGIAN_ERROR_KEYS.EXCLUDED,
  1002: BELGIAN_ERROR_KEYS.UNDER_AGE,
  1003: BELGIAN_ERROR_KEYS.EXPIRED,
  1004: BELGIAN_ERROR_KEYS.UNREADABLE,
  1005: BELGIAN_ERROR_KEYS.UNAVAILABLE,

  // String fallbacks — defensive in case the native side ships symbolic codes
  // instead of (or alongside) numeric ones. Cheap to keep, makes the resolver
  // tolerant of either contract.
  EXCLUDED: BELGIAN_ERROR_KEYS.EXCLUDED,
  EPIS: BELGIAN_ERROR_KEYS.EXCLUDED,
  UNDER_AGE: BELGIAN_ERROR_KEYS.UNDER_AGE,
  UNDERAGE: BELGIAN_ERROR_KEYS.UNDER_AGE,
  AGE: BELGIAN_ERROR_KEYS.UNDER_AGE,
  EXPIRED: BELGIAN_ERROR_KEYS.EXPIRED,
  CARD_EXPIRED: BELGIAN_ERROR_KEYS.EXPIRED,
  UNREADABLE: BELGIAN_ERROR_KEYS.UNREADABLE,
  CARD_UNREADABLE: BELGIAN_ERROR_KEYS.UNREADABLE,
  READ_ERROR: BELGIAN_ERROR_KEYS.UNREADABLE,
  UNAVAILABLE: BELGIAN_ERROR_KEYS.UNAVAILABLE,
  SERVICE_UNAVAILABLE: BELGIAN_ERROR_KEYS.UNAVAILABLE,
};

// Resolves a Code from the native verification response into a category key.
// Returns `null` when Code is null/undefined (caller should treat as "no
// error") and falls back to `unavailable` for unrecognised non-null codes so
// the user still gets a meaningful message instead of a blank banner.
export const resolveBelgianErrorKey = (code) => {
  if (code === null || code === undefined || code === '') return null;

  // Numeric direct hit
  if (CODE_TO_KEY[code]) return CODE_TO_KEY[code];

  // String hit (case-insensitive)
  if (typeof code === 'string') {
    const upper = code.trim().toUpperCase();
    if (CODE_TO_KEY[upper]) return CODE_TO_KEY[upper];
  }

  return BELGIAN_ERROR_KEYS.UNAVAILABLE;
};
